module.exports = __webpack_public_path__ + "img/40_38_035_530.b8e828ed.jpg";